import React, { useId, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

export default function InvoiceIconButton({ icon: Icon, label, ariaLabel = label, hint = label, disabled, onClick, danger = false, tour }) {
    const buttonRef = useRef(null);
    const tooltipRef = useRef(null);
    const tooltipId = useId();
    const [visible, setVisible] = useState(false);
    const [position, setPosition] = useState({ left: 0, top: 0 });
    useLayoutEffect(() => {
        if (!visible) return undefined;
        const anchor = buttonRef.current.getBoundingClientRect();
        const tooltip = tooltipRef.current.getBoundingClientRect();
        const above = anchor.top - tooltip.height - 8;
        setPosition({
            left: Math.max(8, Math.min(anchor.left + (anchor.width - tooltip.width) / 2, window.innerWidth - tooltip.width - 8)),
            top: above >= 8 ? above : anchor.bottom + 8,
        });
        const dismiss = () => setVisible(false);
        window.addEventListener('scroll', dismiss, true);
        window.addEventListener('resize', dismiss);
        return () => { window.removeEventListener('scroll', dismiss, true); window.removeEventListener('resize', dismiss); };
    }, [visible, hint]);

    return <span className="esave-icon-action" onMouseEnter={() => setVisible(true)} onMouseLeave={() => setVisible(false)}>
        <button ref={buttonRef} type="button" data-tour={tour} disabled={disabled} aria-label={ariaLabel} aria-describedby={visible ? tooltipId : undefined}
            className={`esave-button esave-icon-button${danger ? ' esave-button-danger' : ''}`}
            onFocus={() => setVisible(true)} onBlur={() => setVisible(false)} onKeyDown={event => { if (event.key === 'Escape') setVisible(false); }}
            onClick={event => { setVisible(false); onClick?.(event); }}>
            <Icon size={18} aria-hidden="true" /><span className="sr-only">{label}</span>
        </button>
        {visible && createPortal(<div ref={tooltipRef} id={tooltipId} role="tooltip" className="esave-workspace esave-grid-tooltip" style={position}>{hint}</div>, document.body)}
    </span>;
}
